import { render, staticRenderFns } from "./SecurityGroupsView.vue?vue&type=template&id=5dd66a6b&scoped=true&"
import script from "./SecurityGroupsView.vue?vue&type=script&lang=js&"
export * from "./SecurityGroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd66a6b",
  null
  
)

export default component.exports